import React from 'react';
import "./Products.css";

const Products = ({productName, price, image, productLink}) => {
    return(
        <a href={productLink} className='product-link' target="_blank" rel="noopener noreferrer">
            <div className='product-box'>
                <img src={image} alt='Product logo' className='productimg'></img>
                <text className='product-name'>{productName}</text>
                <text className='price'>${price}</text>
            </div>
        </a>
    );
};

export default Products;
